import React from "react";

// The "● Title  count  hint ... actions" row above each tab's list.
const SectionHeader = ({ title, count, hint, children }) => (
  <div className="flex flex-wrap items-center gap-x-2.5 gap-y-2">
    <span className="h-2 w-2 rounded-full bg-state-success-dot" />
    <h2 className="m-0 text-base font-semibold text-ui-text">{title}</h2>
    <span className="rounded-full bg-state-neutral-bg px-2 py-px text-[11px] font-semibold text-state-neutral-text">
      {count}
    </span>
    <span className="order-[99] basis-full text-xs text-ui-text-muted sm:order-none sm:basis-auto">
      {hint}
    </span>
    <div className="ml-auto flex flex-wrap items-center gap-2">{children}</div>
  </div>
);

export default SectionHeader;
